import { DeployMetrics, Plan } from "@/types";

// Mock API responses
const mockDelay = (ms: number = 1000) =>
  new Promise((resolve) => setTimeout(resolve, ms));

// Plans API
export const plansApi = {
  getPlans: async (): Promise<Plan[]> => {
    await mockDelay();
    return [
      {
        id: "plan-1",
        name: "Starter",
        description: "Perfect for small projects and personal use",
        maxUsers: 1,
        costPerUserCents: 999,
        intervalMonths: 1,
        currency: "USD",
        active: true,
      },
      {
        id: "plan-2",
        name: "Free",
        description: "Ideal for growing teams and businesses",
        maxUsers: 10,
        costPerUserCents: 0,
        intervalMonths: 1,
        currency: "USD",
        active: true,
      },
      {
        id: "plan-3",
        name: "Enterprise",
        description: "For large organizations with advanced needs",
        maxUsers: 100,
        costPerUserCents: 9999,
        intervalMonths: 1,
        currency: "USD",
        active: true,
      },
    ];
  },

  subscribeToPlan: async (_: string): Promise<{ success: boolean }> => {
    await mockDelay(2000);
    return { success: true };
  },
};

// Metrics API
export const metricsApi = {
  getDeployMetrics: async (deployId: string): Promise<DeployMetrics[]> => {
    await mockDelay();
    return [
      {
        deployId,
        timestamp: "2024-01-20T10:00:00Z",
        cpuUsage: 45.2,
        memoryUsage: 67.8,
        requestsPerSecond: 124,
        egressBytes: 1024000,
      },
      {
        deployId,
        timestamp: "2024-01-20T11:00:00Z",
        cpuUsage: 52.1,
        memoryUsage: 71.3,
        requestsPerSecond: 156,
        egressBytes: 1540000,
      },
    ];
  },
};
